import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"arrow-right\">\n  <polygon points=\"34.47 72.73 65.53 53.9 65.53 46.01 34.47 27.27 34.47 38.72 54.93 49.91 54.93 50.09 34.47 61.28\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol